import React, { Component } from 'react';
import Link from 'gatsby-link';
import GolfBG from '../assets/images/btn-golf.jpg';
import leQGBG from '../assets/images/btn-leqg.jpg';
import TreesomeBG from '../assets/images/btn-treesome.jpg';
import ArtistoBG from '../assets/images/btn-artisto.jpg';
import FairgroundBG from '../assets/images/btn-fairground.jpg';
import cateringBG from '../assets/images/btn-catering.jpg';
import { artistoPath, cateringPath, fairgroundPath, golfBrauPath, leQGPath, treesomePath } from '../assets/paths';

class SideShortcut extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.state = {
      isOpen: false,
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
    document
      .getElementsByClassName('side-shortcut')
      .item(0)
      .classList.toggle('side-shortcut-open');
  }

  open() {
    this.setState({
      isOpen: true,
    });
    document
      .getElementsByClassName('side-shortcut')
      .item(0)
      .classList.add('side-shortcut-open');
  }

  close() {
    this.setState({
      isOpen: false,
    });
    document
      .getElementsByClassName('side-shortcut')
      .item(0)
      .classList.remove('side-shortcut-open');
  }

  render() {
    return (
      <nav className="side-shortcut" onMouseOver={this.open} onMouseLeave={this.close}>
        <Link to={golfBrauPath}>
          <div style={{ backgroundImage: `url(${GolfBG})` }} className="side-shortcut-element" />
        </Link>
        <Link to={leQGPath}>
          <div style={{ backgroundImage: `url(${leQGBG})` }} className="side-shortcut-element" />
        </Link>
        <Link to={treesomePath}>
          <div style={{ backgroundImage: `url(${TreesomeBG})` }} className="side-shortcut-element" />
        </Link>
        <Link to={artistoPath}>
          <div style={{ backgroundImage: `url(${ArtistoBG})` }} className="side-shortcut-element" />
        </Link>
        <Link to={cateringPath}>
          <div style={{ backgroundImage: `url(${cateringBG})` }} className="side-shortcut-element" />
        </Link>
        <Link to={fairgroundPath}>
          <div style={{ backgroundImage: `url(${FairgroundBG})` }} className="side-shortcut-element" />
        </Link>
        <span className="btn-side-shortcut" onClick={this.toggle}>
          {this.state.isOpen ? <span className="fas fa-2x fa-caret-left" /> : <span className="fas fa-2x fa-caret-right" />}
        </span>
      </nav>
    );
  }
}

export default SideShortcut;



// WEBPACK FOOTER //
// ./src/components/SideShortcut.js